var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(_vm.error.statusCode === 404)?_c('NotFound'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }